module.exports = __webpack_public_path__ + "static/media/paskola-23.bccfb100.png";